// /reset-password?token=... (FR-039 to FR-042; P-AUTH-1).
import { PasswordLinkScreen } from "./PasswordLinkScreen";

export function ResetPasswordScreen() {
  return <PasswordLinkScreen page="reset" />;
}
